import React, { useCallback } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { useIdentificationContext } from '../IdentificationContext';
import { translate } from '../../utils/translate';
import { emailValidator } from '../../utils/validators';

interface ForgetPasswordLinkProps {
    usernameOrEmail?: string;
    onResetPassword(): void;
}
export const ForgetPasswordLink: React.FC<ForgetPasswordLinkProps> = ({ usernameOrEmail = '', onResetPassword }) => {
    const { setEmail } = useIdentificationContext();

    const onClick = useCallback(() => {
        const shouldPrefillEmail = emailValidator().safeParse(usernameOrEmail).success;
        setEmail(shouldPrefillEmail ? usernameOrEmail : '');

        onResetPassword();
    }, [onResetPassword, setEmail, usernameOrEmail]);

    return (
        <Container display="flex" justifyContent="flexEnd" marginTop="1">
            <Typography onClick={onClick} cursor="pointer" decoration="underline" color="grey_1200" size="b_sm">
                {translate('general.forget_password_link')}
            </Typography>
        </Container>
    );
};
